import React from "react";
import style from "./CategoryAccordion.module.scss";
import { MaterialCard } from "../Products/MaterialCard";
import ArrowDown from "../../../../static/images/arrow_down_chevron_icon.svg"

export const CategoryAccordion = ({ categories = [], expandedKeys, onToggle, onCardClick, loading }) => {
  if (loading) {
    return (
      <div className={style.accordionList}>
        {[0, 1].map((i) => (
          <div key={i} className={style.accordionItem}>
            <div className={style.skeletonHeader} />
            <div className={style.materialGrid}>
              {[0, 1, 2].map((j) => (
                <div key={j} className={style.skeletonCard} />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!categories.length) {
    return (
      <div className={style.emptyState}>
        <p>No materials found.</p>
      </div>
    );
  }

  return (
    <div className={style.accordionList}>
      {categories.map((category) => {
        const isExpanded = expandedKeys.includes(category.productCategoryDesc);
        return (
          <div key={category.productCategoryDesc} className={`${style.accordionItem} ${isExpanded ? style.expanded : ""}`}>
            <button type="button" className={style.accordionHeader} onClick={() => onToggle(category.productCategoryDesc)} aria-expanded={isExpanded}>
              <span className={style.accordionTitle}>{category.productCategoryDesc}</span>
              <span className={style.accordionCount}>{category.materials?.length ?? 0}</span>
              <img src={ArrowDown} alt="Expand" className={`${style.accordionChevron} ${isExpanded ? style.accordionChevronOpen : ""}`}  />
            </button>

            <div className={style.accordionContent}>
              <div className={style.accordionContentInner}>
                <div className={style.materialGrid}>
                  {category.materials?.map((material) => (
                    <MaterialCard key={material.materialId} material={material} onClick={() => onCardClick(material.materialId)} type={"FORMULARY"} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
